var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../service/api.service';
import { ContentBaseService } from '../../../component/base/contentbase.service';
var ZipService = /** @class */ (function (_super) {
    __extends(ZipService, _super);
    function ZipService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    ZipService.prototype.getPost = function (zip) {
        this.baseUrl = '/v1/gen/post-m-api?query={"orderByList": [{"name":"post_id","direction":"asc"}],"predicateList": [{"name":"zip_new","value":"' + zip + '","operator":"eq"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            return data.items;
        }));
    };
    ZipService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ZipService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return ZipService;
}(ContentBaseService));
export { ZipService };
var Post = /** @class */ (function () {
    function Post() {
    }
    return Post;
}());
export { Post };
var Option = /** @class */ (function () {
    function Option() {
    }
    return Option;
}());
export { Option };
var Map = /** @class */ (function () {
    function Map() {
    }
    return Map;
}());
export { Map };
//# sourceMappingURL=zip.service.js.map